// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__2AKaF","itemQuantity":"MenuItem_itemQuantity__2DmkD","itemName":"MenuItem_itemName__wcJaL","cost":"MenuItem_cost__2aID9"};